module.exports = __webpack_public_path__ + "static/img/waterbump.1b73430.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/waterbump.png
// module id = mZMt
// module chunks = 0